import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
            {/* Brand Column */}
            <div className="lg:col-span-2">
              <div className="flex items-center gap-2.5 mb-4">
                <div className="w-8 h-8 rounded-lg bg-accent-500 flex items-center justify-center">
                  <i className="ri-leaf-line text-lg text-background-50"></i>
                </div>
                <span className="text-lg font-heading font-semibold text-background-50 tracking-tight">
                  VigorBuy
                </span>
                <span className="ml-1 w-1.5 h-1.5 rounded-full bg-accent-400"></span>
              </div>
              <p className="text-sm text-background-300 leading-relaxed max-w-sm mb-6">
                Your trusted resource for organized Vigorbuy Spreadsheet guides,
                category comparisons, and product discovery tools. Helping
                thousands navigate fashion categories efficiently since 2025.
              </p>
              <div className="flex items-center gap-3">
                <a
                  href="#"
                  className="w-9 h-9 rounded-lg border border-background-600 flex items-center justify-center text-background-300 hover:text-accent-400 hover:border-accent-400 transition-colors duration-200"
                  aria-label="Twitter"
                >
                  <i className="ri-twitter-x-line"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 rounded-lg border border-background-600 flex items-center justify-center text-background-300 hover:text-accent-400 hover:border-accent-400 transition-colors duration-200"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-line"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 rounded-lg border border-background-600 flex items-center justify-center text-background-300 hover:text-accent-400 hover:border-accent-400 transition-colors duration-200"
                  aria-label="Pinterest"
                >
                  <i className="ri-pinterest-line"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 rounded-lg border border-background-600 flex items-center justify-center text-background-300 hover:text-accent-400 hover:border-accent-400 transition-colors duration-200"
                  aria-label="TikTok"
                >
                  <i className="ri-tiktok-line"></i>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4 tracking-wide">
                Quick Links
              </h4>
              <div className="flex flex-col gap-2.5">
                <a
                  href="#what-is"
                  className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200"
                >
                  What Is Vigorbuy
                </a>
                <a
                  href="#benefits"
                  className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200"
                >
                  Benefits
                </a>
                <a
                  href="#how-it-works"
                  className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200"
                >
                  How It Works
                </a>
                <a
                  href="#categories"
                  className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200"
                >
                  Categories
                </a>
                <a
                  href="#faq"
                  className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200"
                >
                  FAQ
                </a>
              </div>
            </div>

            {/* Resources */}
            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4 tracking-wide">
                Resources
              </h4>
              <div className="flex flex-col gap-2.5">
                <Link
                  to="/vigorbuy-spreadsheet-guide"
                  className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200"
                >
                  Complete Guide
                </Link>
                <a
                  href="#safety"
                  className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200"
                >
                  Safety Information
                </a>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200"
                >
                  Visit Main Site
                </a>
              </div>
            </div>

            {/* Legal */}
            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4 tracking-wide">
                Legal
              </h4>
              <div className="flex flex-col gap-2.5">
                <a
                  href="#"
                  className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200"
                >
                  Privacy Policy
                </a>
                <a
                  href="#"
                  className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200"
                >
                  Disclaimer
                </a>
                <a
                  href="#"
                  className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200"
                >
                  Editorial Policy
                </a>
                <a
                  href="#"
                  className="text-sm text-background-300 hover:text-accent-400 transition-colors duration-200"
                >
                  Terms of Use
                </a>
              </div>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; {currentYear} VigorBuy Beauty. All rights reserved. This
              is an informational website. We are not affiliated with any
              specific brand mentioned.
            </p>
            <p className="text-xs text-background-500">
              Made with <i className="ri-heart-line text-accent-500"></i> for
              smart shoppers
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}